export const RULE_EDIT_DATA = "RULE_EDIT_DATA";
export const CARRIER_SETTING_ID = "CARRIER_SETTING_ID";
export const SET_RULE_PRIORITY = "SET_RULE_PRIORITY";

export const setCarrierSettingEditData = (payload) => ({
	type: RULE_EDIT_DATA,
	payload,
});

export const setCarrierSettingId = (payload) => ({
	type: CARRIER_SETTING_ID,
	payload,
});
export const setRulePriority = (payload) => ({
	type: SET_RULE_PRIORITY,
	payload,
});
